export const fieldsTo = {
  text: [
    {
      name: 'toName',
      label: 'Recipient’s Name',
      maxLength: 50,
      type: 'text',
      autocomplete: 'off',
    },
    {
      name: 'toPhone',
      label: 'Recipient’s Phone Number',
      maxLength: 10,
      type: 'tel',
      autocomplete: 'off',
    },
    {
      name: 'toPhoneConfirm',
      label: 'Confirm Recipient’s Phone Number',
      maxLength: 10,
      type: 'tel',
      autocomplete: 'off',
    },
  ],
  email: [
    {
      name: 'toName',
      label: 'Recipient’s Name',
      maxLength: 50,
      type: 'text',
      autocomplete: 'off',
    },
    {
      name: 'toEmail',
      label: 'Recipient’s Email',
      maxLength: 50,
      type: 'email',
      autocomplete: 'off',
    },
    {
      name: 'toEmailConfirm',
      label: 'Confirm Recipient’s Email',
      maxLength: 50,
      type: 'email',
      autocomplete: 'off',
    },
  ],
  printAdHome: [
    {
      name: 'toName',
      label: 'Recipient’s Name',
      maxLength: 30,
      type: 'text',
      autocomplete: 'off',
    },
  ],
};

export const fieldsFrom = {
  text: [
    {
      name: 'fromName',
      label: 'Your Name',
      maxLength: 50,
      type: 'text',
      autocomplete: 'name',
    },
    {
      name: 'fromPhone',
      label: 'Your Phone Number',
      maxLength: 10,
      type: 'tel',
      autocomplete: 'tel',
    },
  ],
  email: [
    {
      name: 'fromName',
      label: 'Your Name',
      maxLength: 50,
      type: 'text',
      autocomplete: 'name',
    },
  ],
  printAdHome: [
    {
      name: 'fromName',
      label: 'Your Name',
      maxLength: 50,
      type: 'text',
      autocomplete: 'name',
    },
    {
      name: 'fromEmail',
      label: 'Your Email',
      maxLength: 50,
      type: 'email',
      autocomplete: 'email',
    },
  ],
};
